/**
 * Every string this UI matches against the advisor backend, in one place.
 *
 * BlockRenderer picks a specialised renderer by node id and by column header, and S4's blocks
 * key their colour markers off line-item labels. That coupling is silent — a copy change on the
 * backend just degrades a rich view to a plain table, with nothing to catch it. Keep in sync
 * with the offer-advisor service.
 */

export const ADVISOR_NODE = {
  /** Market percentiles — a card grid, or a grouped bar chart of the same numbers. */
  MARKET: "S1A_MARKET",
  /** Internal peer distribution — a marker table, or a line chart of the same numbers. */
  INTERNAL: "S1B_INTERNAL",
  /** The final package recommendation. */
  RECOMMEND: "S4_RECOMMEND",
  /** The side-by-side comparison of the recommendation against every variant explored. */
  COMPARE: "S5D_COMPARE",
} as const;

/** First-column (and, for S4's comparisons, second-column) headers used to identify a table. */
export const ADVISOR_COLUMN = {
  BONUS_COMPONENT: "Bonus component",
  COMPARED_TO: "Compared to",
  THIS_OFFER_IS: "This offer is",
  PEER_WATERFALL_LAYER: "Layer",
  PEER_WATERFALL_MEDIAN: "Peer median",
} as const;

/**
 * Every line the S4/COMPLETE package card can emit. Optional ones are omitted entirely when
 * zero, so read by label and never by index.
 */
export const ADVISOR_LINE_ITEM = {
  ANNUAL_BASE: "Annual Base",
  CASH_ALLOWANCES: "Cash Allowances",
  DISCRETIONARY_ALLOWANCES: "Additional allowances (discretionary)",
  TOTAL_GUARANTEED_CASH: "Total Guaranteed Cash",
  TARGET_BONUS: "Target Bonus",
  DISCRETIONARY_BONUS: "Additional bonus (discretionary)",
  TARGET_TOTAL_CASH: "Target Total Cash",
  ANNUAL_EQUITY: "Annual Equity",
  SIGN_ON: "One-Time Sign-On",
} as const;
